import React from 'react';
import { spinner_dotted } from '../../../assets/images';

const Spinner = ({ classes='' }) => {
  return <img src={spinner_dotted} alt='' className={`inline animate-spin ${classes}`} />;
};

export default Spinner;